module.exports = __webpack_public_path__ + "media/haze.8723f451.mp3";